<template>
<div class="double-loader"></div>
</template>

  
<script>
export default {
    name: 'DoubleLoader'
}
</script>

  
<style scoped>
.double-loader {
    width: 100%;
    height: 100%;
    border-radius: 50%;
    position: relative;
    animation: double-rotate 1s linear infinite;
}

.double-loader::before,
.double-loader::after {
    content: "";
    box-sizing: border-box;
    position: absolute;
    inset: 0px;
    border-radius: 50%;
    border: 5px solid #3E5550;
    animation: double-prixClipFix 2s linear infinite;
}

.double-loader::after {
    border-color: #56C0A5;
    animation: double-prixClipFix 2s linear infinite, double-rotate 0.5s linear infinite reverse;
    inset: 6px;
}

@keyframes double-rotate {
    0% {
        transform: rotate(0deg);
    }

    100% {
        transform: rotate(360deg);
    }
}

@keyframes double-prixClipFix {
    0% {
        clip-path: polygon(50% 50%, 0 0, 0 0, 0 0, 0 0, 0 0);
    }

    25% {
        clip-path: polygon(50% 50%, 0 0, 100% 0, 100% 0, 100% 0, 100% 0);
    }

    50% {
        clip-path: polygon(50% 50%, 0 0, 100% 0, 100% 100%, 100% 100%, 100% 100%);
    }

    75% {
        clip-path: polygon(50% 50%, 0 0, 100% 0, 100% 100%, 0 100%, 0 100%);
    }

    100% {
        clip-path: polygon(50% 50%, 0 0, 100% 0, 100% 100%, 0 100%, 0 0);
    }
}
</style>



// WEBPACK FOOTER //
// src/components/UIComponents/loaders/DoubleLoader.vue